import { render, staticRenderFns } from "./dialogRecord.vue?vue&type=template&id=316b5daa&scoped=true&"
import script from "./dialogRecord.vue?vue&type=script&lang=js&"
export * from "./dialogRecord.vue?vue&type=script&lang=js&"
import style0 from "./dialogRecord.vue?vue&type=style&index=0&id=316b5daa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316b5daa",
  null
  
)

export default component.exports